/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Transactions_TransactionExportRequestDto } from '../models/Wealthlane_AwardService_Dtos_Transactions_TransactionExportRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransactionImportService {

    /**
     * @param taskId 
     * @param fileName 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransactionImportExportTransactions(
taskId: string,
fileName?: string,
requestBody?: Wealthlane_AwardService_Dtos_Transactions_TransactionExportRequestDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transaction-import/export-transactions/{taskId}',
            path: {
                'taskId': taskId,
            },
            query: {
                'fileName': fileName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
